import qs from 'qs';

export const mergeQuery = query => {
  let currentQuery = qs.parse(window.location.search.substring(1));

  return `?${qs.stringify({ ...currentQuery, ...query })}`;
};

export const getQuery = query => qs.parse(window.location.search.substring(1));
